<h2 mat-dialog-title>Contact us</h2>
<mat-dialog-content class="mat-typography">
  <p>Please feel free to contact the respective contributor for any queries or feedback</p>
  <div class="orgs">
    @for (org of orgs; track org) {
      <div class="org">
        <div>{{org.name}}</div>
        <hr class="style">
        @for (email of org.emails; track email) {
          <div>
            <a [href]="'mailto:'+email">{{email}}</a>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>